import { useState, useEffect, useContext } from "react";
import { AppContext } from "../Context";
import { degToRad } from "three/src/math/MathUtils.js";

function FabricView() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const [opacity, setOpacity] = useState(0);
    const [display, setDisplay] = useState("none");
    const [src, setSrc] = useState(null);

    useEffect(() => {
        if (state.fabricView) {
            if (state.fabricView == "shirt") {
                setSrc(process.env.PUBLIC_URL + "/fabrics/" + state.fabricCategory + "/" + state.fabricShirt);
            } else {
                setSrc(process.env.PUBLIC_URL + "/fabrics/" + state.fabricCategory + "/" + state.fabricTile);
            }
            setDisplay("flex");
            setTimeout(() => {
                requestAnimationFrame(() => {
                    setOpacity(1);
                });
            }, 10);
        } else if (display !== "none") {
            setOpacity(0);
        }
    }, [state.fabricView, state.fabricShirt, , state.fabricTile]);
    function onClose() {
        dispatch({ type: "SET_FABRIC_VIEW", payload: null });
    }
    function onTransEnd(e) {
        if (e.propertyName === "opacity" && opacity === 0) {
            setDisplay("none");
            setSrc(null);
        }
    }
    return (
        <div onTransitionEnd={onTransEnd} className="FabricView" style={{ display: display, opacity: opacity }}>
            <img className={state.fabricView == "shirt" ? "shirtView" : "tileView"} src={src} />
            <img onClick={onClose} style={{ position: "absolute", height: "4%", right: "10px", top: "10px", cursor: "pointer" }} src={process.env.PUBLIC_URL + "/images/close.svg"} />
        </div>
    );
}
export default FabricView;
